import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "./css/Joinnow.css";
import Footer from "../components/Footer";
import { getCall } from "../utils/Network";
import Loader from "../components/Loader";
import scrollToTop from "../components/hooks/ScrollToTop";
import LanguageDropdown from "../components/LanguageDropdown";

const ApiKey = process.env.REACT_APP_API_KEY;

const JoinNow = () => {
  const inputRef = useRef(null);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);
  
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const [enrollerCode, setEnrollerCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // Enrollers Referral Code Change Function
  const fnChangeCode = (event) => {
    setEnrollerCode(event.target.value);
  };

  // Enroll Function

  const fnEnroll = async () => {
    if (enrollerCode == "") {
      setErrorMsg("Please enter enroller's referral code");
      return false;
    }

    const myHeaders = { "API-key": ApiKey };

    try {
      setIsLoading(true);
      let response = await getCall({
        url: "getAssociateByWebAlias",
        urlParams: { webAlias: enrollerCode },
        header: myHeaders,
      });

      if (response && response?.data?.associateId) {
        sessionStorage.setItem("enroller", JSON.stringify(response.data));
        setIsLoading(false);
        // navigate("/" + enrollerCode + "/Enroll");
        window.location.href = `${"/" + enrollerCode + "/Enroll"}`;
      } else {
        setErrorMsg(t("pleaseEnterValidReferralCode"));
        // setErrorMsg('enrollerReferralNotValid');
        setIsLoading(false);
        return false;
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error:", error);
    }

    setErrorMsg("");
  };

    const checkKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      fnEnroll();
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="img-bg">
        <div className="enrollment-navbar">
          {" "}
          <a href="/">
            <div
              className="noa-logo colored-logo"
              style={{ cursor: "pointer" }}
            ></div>{" "}
          </a>
          <LanguageDropdown />
        </div>
        <div className="dark-mode">
          <div className="main-join-now">
            <p className="heading-enroll">
              {t("unlockYour")}
              <br />
              {t("potential")}
            </p>
            <div className="noa-heading"></div>

            <form
              action="/enrollment"
              onSubmit={() => {
                return false;
              }}
            >
              <div className="input-wrapper">
                <div className="errormsg-wrapper">
                  <p className="enter-referral">
                    {t("enterTheReferralCodeOfThe")}
                  </p>
                  <input
                    type="text"
                    placeholder={t("EnrollerReferralCode")}
                    className="input-join"
                    maxLength={40}
                    onChange={fnChangeCode}
                    onKeyDown={checkKeyPress}
                    ref={inputRef}
                  />
                  <div className="err-message">
                    <small style={{ marginLeft: "9px" }}>{errorMsg}</small>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <div className="navbar-button-wrapper btn-custom-signup">
                  <div className="primary-button-wrapper">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        fnEnroll();
                      }}
                      data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                      className="primary-button w-inline-block"
                    >
                      <div className="primary-button-border-wrap">
                        <div className="primary-button-wrap">
                          <div className="primary-button-text">
                            {t("continue")} &nbsp;&nbsp;➜
                          </div>
                          <div className="primary-button-hover-text">
                            {t("continue")} &nbsp;&nbsp;➜
                          </div>
                          <div className="primary-button-hover-bg"></div>
                        </div>
                      </div>
                      <div className="line-wrap">
                        <div className="primary-line-wrap _1">
                          <div className="line _1"></div>
                          <div className="line _2"></div>
                        </div>
                        <div className="primary-line-wrap _2">
                          <div className="line _3"></div>
                          <div className="line _4"></div>
                        </div>
                        <div className="primary-line-wrap _3">
                          <div className="line _5"></div>
                          <div className="line _6"></div>
                        </div>
                        <div className="primary-line-wrap _4">
                          <div className="line _7"></div>
                          <div className="line _8"></div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div className="menu-button w-nav-button">
                    <div
                      data-is-ix2-target="1"
                      className="hamburger-menu-icon"
                      data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                      data-animation-type="lottie"
                      data-src="/images/hamburger-20menu.lottie"
                      data-loop="0"
                      data-direction="1"
                      data-autoplay="0"
                      data-renderer="svg"
                      data-duration="0"
                      data-ix2-initial-state="0"
                    >
                      <span style={{ color: "#ffffff" }}>
                        <img
                          src="/images/Hamburger_icon.png"
                          alt=""
                          style={{ width: "30%" }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JoinNow;
